import BaseResource from './base/BaseResource'

/**
 * Ukazka moznosti dedeni v js mezi tridami
 *
 */
export default new class TaskResource extends BaseResource {

  constructor () {
    super('tTask')
  }

}
